export default "__VITE_ASSET__V6dJ$JVp__"